import { MutableRefObject, useEffect, useState } from "react";

export const useTextClamp = (
  ref: MutableRefObject<any>,
  additionalListener?: string | boolean | number | any[]
) => {
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (ref && ref.current) {
        setIsClamped(ref.current.scrollHeight > ref.current.clientHeight);
      }
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [ref, additionalListener]);

  return { isClamped };
};
